import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const instance = axios.create({
  baseURL: API,
  withCredentials: true,
});

instance.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401 && !err.config._retry && !err.config.url.includes("/auth/")) {
      err.config._retry = true;
      try {
        await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
        return instance(err.config);
      } catch (_) { /* fall through */ }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default instance;
